const convertUnit = (quantity, sourceUnit, targetUnit) => {
  if (sourceUnit.unit === targetUnit.unit) {
    return quantity;
  }

  let factor = sourceUnit.conversionFactor > 0 ? sourceUnit.conversionFactor : 1,
    targetFactor = targetUnit.conversionFactor > 0 ? targetUnit.conversionFactor : 1;

  quantity = quantity * factor;

  return quantity / targetFactor;
}

export default convertUnit;